module.exports = function () {
    return ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'];
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/iana-hashes/lib/get-hashes-browser.js
// module id = 300
// module chunks = 0